import type { SVGProps } from "react";

export const Plus = (props: SVGProps<SVGSVGElement>) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width="18"
		height="18"
		fill="none"
		viewBox="0 0 18 18"
		{...props}
	>
		<path stroke="#0E0E0E" d="M9.143 1v16m7.786-8H1.357" />
	</svg>
);
